/**
 * @generated SignedSource<<36001b42ff46a3fc05355ca3697c3d5a>>
 * @relayHash 4d2491897168f28c5a7445ce3d890969
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eab4de8be77c765639be9c158bfecc7cdc210673c5175259ae9f19a1dc31db95

import type { ConcreteRequest } from 'relay-runtime';
export type AssetsDMAdvisoryNotificationSeverity = "ERROR" | "INFO" | "WARNING" | "%future added value";
export type AssetsDMAdvisoryNotificationType = "ADAPTER_CLIENT_UPDATE_AVAILABLE" | "ADAPTER_CLIENT_UPDATE_REQUIRED" | "COMPUTED_ISSUES" | "FAILED_CLEANSE_AND_IMPORT" | "FAILED_JOB_EXECUTIVES" | "UNMAPPED_OBJECTS_ISSUES" | "%future added value";
export type DataManagerAdvisoryNotificationsQuery$variables = {
  cloudId: string;
  workspaceId: string;
};
export type DataManagerAdvisoryNotificationsQuery$data = {
  readonly assetsDM_advisoryNotifications: {
    readonly notifications: ReadonlyArray<{
      readonly severity: AssetsDMAdvisoryNotificationSeverity;
      readonly type: AssetsDMAdvisoryNotificationType;
    } | null> | null;
  } | null;
};
export type DataManagerAdvisoryNotificationsQuery = {
  response: DataManagerAdvisoryNotificationsQuery$data;
  variables: DataManagerAdvisoryNotificationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "workspaceId",
        "variableName": "workspaceId"
      }
    ],
    "concreteType": "AssetsDMAdvisoryNotificationsResponse",
    "kind": "LinkedField",
    "name": "assetsDM_advisoryNotifications",
    "plural": false,
    "selections": [
      {
        "concreteType": "AssetsDMAdvisoryNotification",
        "kind": "LinkedField",
        "name": "notifications",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "kind": "ScalarField",
            "name": "severity"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "DataManagerAdvisoryNotificationsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DataManagerAdvisoryNotificationsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "eab4de8be77c765639be9c158bfecc7cdc210673c5175259ae9f19a1dc31db95",
    "metadata": {},
    "name": "DataManagerAdvisoryNotificationsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "12ce548b5ca9c02f15beb06c6f6f99c4";

export default node;
